import { useMemo } from 'react';

import { FormReadOnlyContext } from './context';

import type { FormReadOnlyProviderProps } from './types';

export default function FormReadOnlyProvider({
  readOnly,
  showValidationErrors = false,
  children,
}: FormReadOnlyProviderProps) {
  const value = useMemo(
    () => ({ readOnly, showValidationErrors }),
    [readOnly, showValidationErrors],
  );

  return <FormReadOnlyContext.Provider value={value}>{children}</FormReadOnlyContext.Provider>;
}
